export enum Roles {
  host = 'host',
  manager = 'manager',
  'manager host' = 'manager host',
  'podcast host' = 'podcast host',
}
